export default {"src":"/_next/static/media/app-store-badge.5f1965ab.svg","height":64,"width":216,"blurWidth":0,"blurHeight":0};